import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import type { Contact } from 'types/list'
import { sortContacts } from '@disco/state-management/actions/contact-actions'
import {
  getContactsAll,
  getContactsFilteredByCampaignRules,
} from '@disco/state-management/selectors/contacts-all'
import { Spinner } from 'components/ui'
import DataTable, { Column } from 'components/ui/data-table'
import Heading from 'components/ui/heading'
import UserAvatar from 'components/ui/user-avatar'
import ContactsMessage from 'pages/contacts/list/contacts-message'

const mapStateToProps = (state: any, ownProps: any) => ({
  ...getContactsAll(state),
  filteredContacts: getContactsFilteredByCampaignRules(state, ownProps)
    .filteredContacts,
  emailGroupsLoaded: state.emailGroups.isFetched,
  beingSearched: state.emailCampaigns.recipientRules.rules.length > 0,
})

const mapDispatchToProps = {
  sortContacts,
}
const DATA_TABLE_COLUMNS: Column[] = [
  {
    contentType: 'button',
    width: 'content',
    render: (prop: Record<string, any>) => (
      <UserAvatar name={prop.name} size="24px" fontSize="11px" />
    ),
  },
  {
    name: 'Name',
    toSortable: (prop: Record<string, any>) => prop.name,
    render: (prop: Record<string, any>) => (
      <Link className="ContactCell_Link" to={`/contacts/${prop.id}`}>
        {prop.name}
      </Link>
    ),
  },
  {
    id: 'email',
    name: 'Email',
  },
  {
    id: 'company',
    name: 'Company',
  },
  {
    id: 'territory',
    name: 'Location',
  },
]
type Props = {
  filteredContacts: Contact[]
  sortContacts: (...args: Array<any>) => any
  sortDirection: string
  sortParam: string
  beingSearched: boolean
  emailGroupsLoaded: boolean
  loaded: boolean
}

class CampaignRecipientList extends React.Component<Props> {
  render() {
    const {
      filteredContacts,
      sortContacts,
      sortDirection,
      sortParam,
      beingSearched,
    } = this.props

    if (!this.props.loaded || !this.props.emailGroupsLoaded) {
      return <Spinner />
    }

    return (
      <React.Fragment>
        <Heading size={500}>
          Sending to {filteredContacts.length} of your contacts
        </Heading>
        <DataTable
          appearance="plain"
          columns={DATA_TABLE_COLUMNS}
          data={filteredContacts}
          emptyState={
            <ContactsMessage
              iconType="search"
              header="Sorry! No contacts found"
              message="Try broadening your search filters"
            />
          }
        />
      </React.Fragment>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CampaignRecipientList) as any
